import React, { useState, useEffect } from "react";
import { Tag } from "antd";
import { tenantService } from "../services/tenantService";

export const TenantTag: React.FC<{ useShortName?: boolean }> = ({ useShortName = false }) => {
  const [, setUpdateTrigger] = useState({});
  const tenantInfo = tenantService.getCurrentTenantDisplayInfo();

  useEffect(() => {
    const unsubscribe = tenantService.subscribe(() => {
      setUpdateTrigger({});
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Tag
      color={tenantInfo.backgroundColor}
      style={{
        height: "40px",
        width: useShortName ? "40px" : "auto",
        borderRadius: "6px",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: "600",
        color: "black",
        padding: useShortName ? undefined : "0 12px",
      }}
    >
      {useShortName ? tenantInfo.shortName : tenantInfo.longName}
    </Tag>
  );
};
